import { useLanguage } from "@/context/language"
import { SettingsListV2 } from "./parts/list"
import { SettingsRowV2 } from "./parts/row"
import { createMemo } from "solid-js"
import { createStore } from "solid-js/store"

export const COWORK_DEFAULT_AGENT_KEY = "cowork.agent.defaultChatAgentId"

export type CoworkDefaultAgentID = "custom-report" | "accounting"

export function CoworkAgentsSettings() {
  const language = useLanguage()
  const [store, setStore] = createStore({ defaultAgentID: storedDefaultAgentID() })
  const agents = createMemo(() => coworkDefaultAgentOptions(language))

  const setDefaultAgent = (agentID: CoworkDefaultAgentID) => {
    localStorage.setItem(COWORK_DEFAULT_AGENT_KEY, agentID)
    setStore("defaultAgentID", agentID)
    window.dispatchEvent(new CustomEvent("cowork:default-agent-changed", { detail: { agentID } }))
  }

  return (
    <>
      <div class="settings-v2-tab-header">
        <h2 class="settings-v2-tab-title">{language.t("cowork.settings.agents.title")}</h2>
        <p class="settings-v2-tab-description">{language.t("cowork.settings.agents.description")}</p>
      </div>

      <SettingsListV2>
        <SettingsRowV2 title={language.t("cowork.settings.agents.default.title")} description={language.t("cowork.settings.agents.default.description")}>
          <select
            class="h-9 min-w-[220px] rounded-md border border-v2-border-border-base bg-v2-background-bg-layer-01 px-2 text-13-regular text-v2-text-text-base outline-none"
            value={store.defaultAgentID}
            onChange={(event) => setDefaultAgent(event.currentTarget.value as CoworkDefaultAgentID)}
          >
            {agents().map((agent) => <option value={agent.id}>{agent.name}</option>)}
          </select>
        </SettingsRowV2>
      </SettingsListV2>
    </>
  )
}

export function storedDefaultAgentID(): CoworkDefaultAgentID {
  const value = localStorage.getItem(COWORK_DEFAULT_AGENT_KEY)
  return value === "accounting" || value === "custom-report" ? value : "custom-report"
}

export function coworkDefaultAgentOptions(language: ReturnType<typeof useLanguage>) {
  return [
    {
      id: "custom-report" as const,
      name: language.t("cowork.agents.template.customReport"),
      description: language.t("cowork.agents.template.customReport.description"),
    },
    {
      id: "accounting" as const,
      name: language.t("cowork.agents.template.accounting"),
      description: language.t("cowork.agents.template.accounting.description"),
    },
  ]
}
